import React, { useContext, useState } from 'react'
import { Context } from '../../../../context/Context';
import { translations } from '../../../../utils/lang';
import { integrationLabel } from '../../../../utils/integrations';
import './MissingTable.css'
import { SparkLineChart } from '@mui/x-charts';
import { areaElementClasses, lineElementClasses } from '@mui/x-charts/LineChart';


export const MissingTable = ({ missing }) => {
    const { lang } = useContext(Context);
    const [expanded, setExpanded] = useState(null);


    const grouped = missing.reduce((acc, row) => {
        const key = `${row.store}|${row.branch}|${row.app}`;
        if (!acc[key]) acc[key] = [];
        acc[key].push(row);
        return acc;
    }, {});


    const groups = Object.entries(grouped).map(([key, rows]) => {
        const sorted = [...rows].sort((a, b) => {
            const [dayA, monA, yearA] = a.date.split(/[-/]/);
            const [dayB, monB, yearB] = b.date.split(/[-/]/);
            return new Date(`${monA} ${dayA}, ${yearA}`) - new Date(`${monB} ${dayB}, ${yearB}`);
        });
        return {
            key,
            main: sorted[sorted.length - 1], // last missing day
            all: sorted
        };
    }).sort((a, b) => {
        const [dayA, monA, yearA] = a.main.date.split(/[-/]/);
        const [dayB, monB, yearB] = b.main.date.split(/[-/]/);
        return new Date(`${monB} ${dayB}, ${yearB}`) - new Date(`${monA} ${dayA}, ${yearA}`);
    });

    const toggleExpand = (key) => {
        setExpanded(expanded === key ? null : key);
    };
    return (
        <div className="daily-analysis-table-scroll-container">
            <h2>{translations[lang].dailyAnalysis.title}</h2>
            <table className="daily-analysis-list-table-container">
                <thead>
                    <tr>
                        {translations[lang].dailyAnalysis.header.map((item, i) =>
                            <th key={i} className="daily-analysis-list-table-header">{item}</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {groups.map(({ key, main, all }) => {
                        const sparkValues = all.map(row =>
                            row.decline === 0 ? 0 : -Math.abs(row.decline)
                        );
                        return (
                            <React.Fragment key={key}>
                                <tr
                                    onClick={() => toggleExpand(key)}
                                    className={`main-row ${expanded === key ? 'active' : ''}`}
                                >
                                    <td>{translations[lang].filter.apps[main.app]}</td>
                                    <td>{main.store}</td>
                                    <td>{main.branch}</td>
                                    <td>{main.date.split('-')[0] + "-" + main.date.split('-')[1]}</td>
                                    <td>
                                        <div className="decline-row">

                                            <p>{main.decline}</p>
                                            <SparkLineChart
                                                data={[0, ...sparkValues]} // force it to be negative
                                                height={30}
                                                width={30}
                                                color={main.decline > 0 ? '#da3b3bff' : '#69122e99'}
                                                area
                                                baseline="zero"
                                                sx={{
                                                    [`& .${lineElementClasses.root}`]: {
                                                        strokeWidth: 1,
                                                    },
                                                    [`& .${areaElementClasses.root}`]: {
                                                        fill: main.decline > 0
                                                            ? 'rgba(185, 78, 78, 0.25)'   // transparent red
                                                            : 'rgba(128,128,128,0.25)',  // transparent gray
                                                        stroke: 'none',
                                                    },
                                                }}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                {expanded === key &&
                                    all.slice(0, -1).slice().reverse().map((row, idx) => (
                                        <tr key={`${row.date}-${idx}`} className="daily-analysis-expanded-row">
                                            <td>{integrationLabel(row.app, lang)}</td>
                                            <td>{row.store}</td>
                                            <td>{row.branch}</td>
                                            <td>{row.date.split('-')[0] + "-" + row.date.split('-')[1]}</td>
                                            <td>
                                                <div className="decline-row">

                                                    <p>{row.decline}</p>
                                                    <SparkLineChart
                                                        data={[0, -Math.abs(row.decline)]} // force it to be negative
                                                        height={30}
                                                        width={30}
                                                        color={row.decline > 0 ? '#da3b3bff' : '#69122e99'}
                                                        area
                                                        baseline="zero"
                                                        sx={{
                                                            [`& .${lineElementClasses.root}`]: {
                                                                strokeWidth: 1,
                                                            },
                                                            [`& .${areaElementClasses.root}`]: {
                                                                fill: row.decline > 0
                                                                    ? 'rgba(185, 78, 78, 0.25)'   // transparent red
                                                                    : 'rgba(128,128,128,0.25)',  // transparent gray
                                                                stroke: 'none',
                                                            },
                                                        }}
                                                    />

                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </React.Fragment>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
